import * as React from "react";
import { observer } from "mobx-react";
import { observable } from "mobx";
import { Alert, Button, Classes, Dialog, FormGroup, InputGroup, Switch } from "@blueprintjs/core";
import { toast } from "react-toastify";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { formatCnpj, getMomentFormatter, municipios_liberados } from "../../utils";
import { BootstrapTable, TableHeaderColumn, SearchField } from "react-bootstrap-table";
import { MDBCol } from "mdbreact";
import { DateInput } from "@blueprintjs/datetime";
import moment from "moment";
import MomentLocaleUtils from "react-day-picker/moment";
import { IAgendamento, newIAgendamento } from "../../model";
import { ParauapebasStore } from "../../stores/parauapebas/ParauapebasStore";


@observer
export default class ParauapebasSolicita extends React.Component<{}, {}> {

  obs = observable({
    agendamento: newIAgendamento() as IAgendamento,
  })

  constructor(props: any) {
    super(props);
  }

  async componentDidMount() {
  }

  handleClose() {

    ParauapebasStore.obs.open_solicitar = false

    this.obs.agendamento.listEmpresas = []
  }

  async handleCreateTask() {

    if (this.obs.agendamento.listEmpresas.length == 0) {
      toast.error("Selecione pelo menos uma Empresa!", {});
      return
    }

    let params: any = {
      recorrente: this.obs.agendamento.recorrente,
      cnpjs: this.obs.agendamento.listEmpresas,
      descricao: this.obs.agendamento.descricao
    }

    if (this.obs.agendamento.recorrente) {

      if (this.obs.agendamento.periodo_selecionado == "") {
        toast.error("Selecione o Período de comunicação!", {});
        return
      }

      if (this.obs.agendamento.periodo_selecionado == "semanal" && this.obs.agendamento.dia == "") {
        toast.error("Selecione o Dia de comunicação!", {});
        return
      }

      params.data_solicitacao = null
      params.periodoNotas = null
      params.periodoAno = null
      params.periodo = this.obs.agendamento.periodo_selecionado
      params.dia = this.obs.agendamento.dia

    } else {

      if (!(this.obs.agendamento.data_solicitacao)) {
        toast.warn("Informe uma Data de Solicitação!", {});
        return
      }

      if (this.obs.agendamento.periodoNotas == "") {
        toast.warn("Selecione o Mês de referência das Notas!", {});
        return
      }

      if (this.obs.agendamento.periodoAno == "") {
        toast.warn("Selecione o Ano de referência das Notas!", {});
        return
      }

      params.data_solicitacao = this.obs.agendamento.data_solicitacao
      params.periodoNotas = this.obs.agendamento.periodoNotas
      params.periodoAno = this.obs.agendamento.periodoAno
      params.periodo = null
      params.dia = null

    }

    ParauapebasStore.obs.open_solicitar = false
    ParauapebasStore.obs.loading_solicitacao = true

    await ParauapebasStore.handleSolicitaParauapebas(params)

    this.obs.agendamento.listEmpresas = []

  }

  handleRowSelect = async (row, checked) => {

    if (checked) {

      this.obs.agendamento.listEmpresas.push(row.cnpj_default);

    } else {

      let index = this.obs.agendamento.listEmpresas.indexOf(row.cnpj_default);

      this.obs.agendamento.listEmpresas.splice(index, 1);

    }

  };

  handleRowSelectAll = async (check, row) => {

    if (check) {

      row?.map(value => {

        this.obs.agendamento.listEmpresas.push(value.cnpj_default);

      });

    } else {

      this.obs.agendamento.listEmpresas = [];
    }

  };

  createCustomSearchField = (props) => {

    return (
      <SearchField
        className="input-filter input-filter-sefa-agendamento"
        defaultValue={props.defaultSearch}
        placeholder="Filtrar (Razão Social, CNPJ)"
      />
    );

  };

  handleDateRealizarChange = (val: Date) => {

    if (val == null) {

      return this.obs.agendamento.data_solicitacao = null

    }

    var string = val.toString();

    var dataAgora = moment().format("YYYY-MM-DD");
    var date1 = moment(string).format("YYYY-MM-DD");

    if (!this.obs.agendamento.recorrente && date1 < dataAgora) {

      toast.warning('Você não pode selecionar uma data inferior ao dia de hoje.', {});
      this.obs.agendamento.data_solicitacao = null

    } else {

      this.obs.agendamento.data_solicitacao = val

    }

  };

  handleAnos() {
    let m = moment();
    let anoAtual = m.year();

    return (<>
      <option value={""}>Selecione um Ano</option>
      {[...Array(6)].map((_, index) => {
        let ano = anoAtual - index;
        return (
          <option key={ano} value={ano}>{ano}</option>
        );
      })}
    </>)
  }

  render() {

    const selectRowProp = {
      mode: "checkbox",
      clickToSelect: true,
      columnWidth: "40px",
      onSelect: this.handleRowSelect,
      onSelectAll: this.handleRowSelectAll,
      isSelected: true,
      selected: this.obs.agendamento.listEmpresas,
      bgColor: "rgba(27, 98, 111, 0.1)",
    };

    const options = {
      searchField: this.createCustomSearchField,
    };

    let select_empresas = EmpresaStore.sortedEmpresas
      .filter(x => municipios_liberados.includes((x.municipio || "").toUpperCase()))
      .map(map_emp => {

        let emp = EmpresaStore.getByCnpj(map_emp.cnpj);

        if (emp && emp.ativo) {

          return ({
            _id: emp._id,
            razao_social: emp.razao_social,
            apelido: emp.apelido,
            cnpj: formatCnpj(emp.cnpj),
            cnpj_default: emp.cnpj
          })

        }

      });

    let dayPickerProps = {
      localeUtils: MomentLocaleUtils,
      locale: "pt-br",
    };

    return (
      <>

        <Dialog
          isOpen={ParauapebasStore.obs.open_solicitar}
          onClose={() => this.handleClose()}
          className="modal-cnds"
        >
          <h2 className="titleSEFAZ">Solicitar NFS-e</h2>

          <div style={{ display: "flex" }}>
            <FormGroup label="Recorrência" />
            &nbsp;
            &nbsp;
            <Switch
              innerLabelChecked="Sim"
              innerLabel="Não"
              checked={this.obs.agendamento.recorrente}
              onChange={(e: any) => this.obs.agendamento.recorrente = e.target.checked}
            />
          </div>

          <FormGroup className="form-group" label="Descrição" style={{ width: "100%" }}>
            <InputGroup type="text" onChange={(e: any) => this.obs.agendamento.descricao = e.target.value} value={this.obs.agendamento.descricao} />
          </FormGroup>

          {this.obs.agendamento.recorrente ?
            <>
              <div style={{ display: "flex" }}>
                <FormGroup label="Período de comunicação" style={{ width: "50%" }}>
                  <select
                    onChange={(e) => this.obs.agendamento.periodo_selecionado = e.target.value}
                    value={this.obs.agendamento.periodo_selecionado}
                    className="bp3-button bp3-align-left"
                  >
                    <option value="">Selecione uma opção</option>
                    <option value={"semanal"}>Semanal</option>
                    <option value={"quinzenal"}>Quinzenal</option>
                    <option value={"mensal"}>Mensal</option>
                  </select>
                </FormGroup>
                &nbsp;
                {this.obs.agendamento.periodo_selecionado == "semanal" &&
                  <FormGroup label="Dia de comunicação" style={{ width: "50%" }}>
                    <select onChange={(e) => this.obs.agendamento.dia = e.target.value} value={this.obs.agendamento.dia} className="bp3-button bp3-align-left">
                      <option value={""}>Selecione uma opção</option>
                      <option value={"7"}>Domingo</option>
                      <option value={"1"}>Segunda-feira</option>
                      <option value={"2"}>Terça-feira</option>
                      <option value={"3"}>Quarta-feira</option>
                      <option value={"4"}>Quinta-feira</option>
                      <option value={"5"}>Sexta-feira</option>
                      <option value={"6"}>Sábado</option>
                    </select>
                  </FormGroup>
                }
              </div>

            </>

            :

            <>
              <div style={{ display: "flex" }}>

                <FormGroup label="Realizar dia" style={{ width: "30%" }}>
                  <DateInput
                    {...getMomentFormatter("DD/MM/YYYY")}
                    locale="pt-br"
                    dayPickerProps={dayPickerProps}
                    placeholder={"DD/MM/AAAA"}
                    onChange={this.handleDateRealizarChange}
                    canClearSelection
                    value={this.obs.agendamento.data_solicitacao}
                  />
                </FormGroup>

                &nbsp;

                <FormGroup label="Período das Notas" style={{ width: "70%" }}>

                  <div style={{ display: "flex" }}>
                    <select onChange={(e) => this.obs.agendamento.periodoNotas = e.target.value} value={this.obs.agendamento.periodoNotas} className="bp3-button bp3-align-left">
                      <option value={""}>Selecione um Mês</option>
                      <option value="01">JANEIRO</option>
                      <option value="02">FEVEREIRO</option>
                      <option value="03">MARÇO</option>
                      <option value="04">ABRIL</option>
                      <option value="05">MAIO</option>
                      <option value="06">JUNHO</option>
                      <option value="07">JULHO</option>
                      <option value="08">AGOSTO</option>
                      <option value="09">SETEMBRO</option>
                      <option value="10">OUTUBRO</option>
                      <option value="11">NOVEMBRO</option>
                      <option value="12">DEZEMBRO</option>
                    </select>

                    &nbsp;

                    <select
                      className="bp3-button bp3-align-left"
                      value={this.obs.agendamento.periodoAno}
                      onChange={(e) => { this.obs.agendamento.periodoAno = e.target.value }}
                      disabled={false}
                    >
                      {this.handleAnos()}
                    </select>

                  </div>

                </FormGroup>

              </div>

            </>
          }

          <FormGroup label="Selecione as Empresas *">
            <div className="select-empresa-sefa sefa-agendamento">
              <BootstrapTable data={select_empresas} selectRow={selectRowProp} options={options} search>
                <TableHeaderColumn dataField="cnpj_default" isKey={true} hidden width="1%">#</TableHeaderColumn>
                <TableHeaderColumn dataField="razao_social" width="60%">Razão Social</TableHeaderColumn>
                <TableHeaderColumn dataField="cnpj" width="30%">CNPJ</TableHeaderColumn>
              </BootstrapTable>
            </div>
          </FormGroup>

          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Cancelar" onClick={() => this.handleClose()} />
            <Button text="Solicitar" intent="primary" onClick={() => this.handleCreateTask()} />
          </div>
        </Dialog>

      </>
    )
  }
}

